import React from "react";
import { Loader2, ShieldAlert } from "lucide-react";
import { StudioProvider, useStudio } from "./StudioContext";
import StudioLogin from "./StudioLogin";
import StudioDashboard from "./StudioDashboard";
import { T } from "./theme";

function Gate() {
  const { user, ready, logout } = useStudio();
  if (!ready || user === undefined) {
    return (
      <div className="min-h-screen flex items-center justify-center" style={{ background: T.bg }}>
        <Loader2 className="animate-spin" style={{ color: T.gold }} size={32} />
      </div>
    );
  }
  if (!user) return <StudioLogin />;

  // Wrong role → do not authorize; force logout with clear message
  if (user.role !== "super_admin") {
    return (
      <div className="min-h-screen flex items-center justify-center px-6" style={{ background: T.bg }}>
        <div className="max-w-md w-full p-8 rounded-2xl text-center"
          style={{ background: T.card, border: `1px solid ${T.border}`, boxShadow: T.shadow }}>
          <div className="w-14 h-14 mx-auto rounded-xl flex items-center justify-center mb-4"
            style={{ background: `${T.danger}22`, color: T.danger }}>
            <ShieldAlert size={26} />
          </div>
          <h2 className="font-display font-extrabold text-xl mb-2" style={{ color: T.text }}>
            Restricted platform
          </h2>
          <p className="text-sm mb-5" style={{ color: T.textDim }}>
            The Yosi Media Studio Agency Portal is available to super administrators only.
            Please use your client portal instead.
          </p>
          <div className="flex gap-2">
            <button onClick={logout}
              className="flex-1 rounded-lg py-2.5 font-semibold text-sm"
              style={{ background: T.input, border: `1px solid ${T.border}`, color: T.text }}>
              Sign out
            </button>
            <a href="/admin"
              className="flex-1 rounded-lg py-2.5 font-semibold text-sm inline-flex items-center justify-center"
              style={{ background: `linear-gradient(135deg, ${T.gold}, ${T.goldHi})`, color: "#0A0A0C" }}>
              Client portal
            </a>
          </div>
        </div>
      </div>
    );
  }

  return <StudioDashboard />;
}

export default function StudioApp() {
  return <StudioProvider><Gate /></StudioProvider>;
}
